import React from "react";
import { BookCover } from "./BookCover";
import { bonuses, volumes } from "../data/landing";
type CollectionMockupProps = {
  src?: string;
  className?: string;
};
const label = "WHY WE BELIEVE collection: 6 digital volumes and 5 bonus guides on book, tablet and phone";

// Temporary coded composition. Set productVisuals.heroMockup / offerMockup to use a real mockup image.
export function CollectionMockup({
  src,
  className = ""
}: CollectionMockupProps) {
  if (src) {
    return <img src={src} alt={label} className={`mx-auto h-auto w-full max-w-[640px] mix-blend-multiply ${className}`} data-id="element-57" data-mp="2x4dhu0rcu2eg" />;
  }
  const [main, ...rest] = volumes;
  const tabletVolume = volumes[1];
  const phoneVolume = volumes[2];
  return <div role="img" aria-label={label} className={`relative mx-auto aspect-[6/5] w-full max-w-[560px] ${className}`} data-id="element-58" data-mp="2nbo7j97jiukp">
      {/* Soft floor */}
      <span className="absolute inset-x-[6%] bottom-[1%] h-[10%] rounded-[50%] bg-navy/10" data-id="element-59" data-mp="2ecaxaeble1yx" />

      {/* Tablet */}
      <div className="absolute left-[1%] top-[15%] w-[38%] -rotate-[5deg] rounded-[8%] bg-navy-deep p-[2.2%] shadow-[0_20px_36px_-16px_rgba(11,24,56,0.6)]" data-id="element-60" data-mp="3ved1msuhonpc">
        <div className="overflow-hidden rounded-[5%] bg-white" data-id="element-61" data-mp="8aq6aviwcdqr">
          <BookCover kicker={`Volume ${tabletVolume.number}`} title={tabletVolume.title} color={tabletVolume.color} icon={tabletVolume.icon} className="!rounded-none !shadow-none" data-id="element-62" data-mp="88vx2egzma2i" />
        </div>
      </div>

      {/* Spine stack — remaining volumes */}
      <div className="absolute right-[2%] top-[9%] flex h-[62%] w-[33%] gap-[2%]" style={{
      containerType: "inline-size"
    }} data-id="element-63" data-mp="3lhi7sn95vbhe">
        {rest.map(v => <div key={v.number} className="relative flex flex-1 flex-col items-center overflow-hidden rounded-[3px] shadow-[0_10px_20px_-10px_rgba(11,24,56,0.6)]" style={{
        backgroundColor: v.color
      }} data-id="element-64" data-mp="3gop1huy1nv37">
            <span className="mt-[30%] h-[2%] w-[70%] bg-[#FFD873]" data-id="element-65" data-mp="rzrheyjcrgk4" />
            <span className="mt-[14%] overflow-hidden text-ellipsis whitespace-nowrap font-display font-bold text-white" style={{
          writingMode: "vertical-rl",
          fontSize: "5.4cqw",
          maxHeight: "70%"
        }} data-id="element-66" data-mp="wy2r999ndr2c">
              {v.title}
            </span>
            <span className="absolute bottom-[4%] font-display font-extrabold text-[#FFD873]" style={{
          fontSize: "6cqw"
        }} data-id="element-67" data-mp="16pyoki3wtd5i">
              {v.number}
            </span>
          </div>)}
      </div>

      {/* Main book */}
      <div className="absolute left-[27%] top-[3%] z-10 w-[42%]" data-id="element-68" data-mp="ixiaeinam5bh">
        <BookCover kicker={`Volume ${main.number}`} title={main.title} color={main.color} icon={main.icon} data-id="element-69" data-mp="n0el7n6lcx4v" />
      </div>

      {/* Phone */}
      <div className="absolute bottom-[3%] left-[3%] z-20 w-[17%] rotate-[4deg] rounded-[14%] bg-navy-deep p-[1.3%] shadow-[0_18px_30px_-12px_rgba(11,24,56,0.6)]" data-id="element-70" data-mp="1ucx1j5stm2yo">
        <div className="flex aspect-[9/17] flex-col overflow-hidden rounded-[11%] bg-white" data-id="element-71" data-mp="3ixccrsp48hkw">
          <BookCover kicker={`Volume ${phoneVolume.number}`} title={phoneVolume.title} color={phoneVolume.color} icon={phoneVolume.icon} className="!rounded-none !shadow-none" data-id="element-72" data-mp="3euzbbghej5tx" />
          <span className="mx-[10%] mt-[10%] h-[3%] rounded-full bg-royal-soft" data-id="element-73" data-mp="355fra7hyd5xh" />
          <span className="mx-[10%] mt-[6%] h-[3%] w-[55%] rounded-full bg-royal-light" data-id="element-74" data-mp="307ea5s437gon" />
        </div>
      </div>

      {/* Bonus guides */}
      <div className="absolute bottom-[2%] right-[1%] z-20 flex w-[58%] justify-end" data-id="element-75" data-mp="2r5wugauldh0h">
        {bonuses.map((b, i) => <div key={b.number} className="w-[27%] shrink-0" style={{
        marginLeft: i === 0 ? 0 : "-9%",
        transform: `rotate(${(i - 2) * 3}deg)`
      }} data-id="element-76" data-mp="2m7d500gshn3d" data-mpi={i}>
            <BookCover variant="bonus" kicker={`Bonus #${b.number}`} title={b.coverTitle} color={b.color} icon={b.icon} data-id="element-77" data-mp="kfqee00t7u7f" />
          </div>)}
      </div>
    </div>;
}